export default __webpack_public_path__ + "static/media/rose.dada213f.png";